// extracted by mini-css-extract-plugin
module.exports =  {"label":"HistoryGroup-module__label--gedM4"};